module.exports = __webpack_public_path__ + "static/img/logo_menu.367d474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_menu.png
// module id = 0yR2
// module chunks = 275